import React from "react"

import CardMember from "../components/CardMember"

import Container from "react-bootstrap/Container"
import CardDeck from "react-bootstrap/CardDeck"

const SectionMembers = ({ managers, lang }) => {
  return (
    <Container as="section" className="contact-member-section my-5">
      <div className="title2 py-5 text-uppercase h3">
        {lang === "ru" ? "Кому задать вопросы?" : "Кому задати питання?"}
      </div>
      <CardDeck className="managers text-white justify-content-center">
        {managers.map(manager => {
          return (
            <CardMember
              key={manager.id}
              fluid={manager.photo.fluid}
              name={manager.name}
              description={manager.description}
              phone={manager.phone}
              viber={manager.viber}
              lang={lang}
              binotelClass={manager.binotelClass}
            />
          )
        })}
      </CardDeck>
    </Container>
  )
}

export default SectionMembers
